export default "__VITE_ASSET__B9DMdl0A__"